<template>
	<div id="app">
		<main class="main">
			<router-view />
		</main>
		<footer-bar></footer-bar>
		<!-- <button v-if="showScrollToTop" @click="scrollToTop" class="scroll-to-top-btn">↑</button> -->
		<div class="rounded-button scroll-to-top-btn">
			<div class="top-button" @click="showRent = true">
				<div class="text-center w-full">
					<img
						:src="require('@/assets/img/iPhone.png')"
						class="Top-img"
						alt=""
					/>
				</div>
				<div>手机端</div>
			</div>
      <div class="top-button" @click="goH5">
        <div class="text-center w-full">
          <img
              :src="require('@/assets/img/Merchant.png')"
              class="Top-img"
              alt=""
          />
        </div>
        <div>招商入驻</div>
      </div>
      <div class="top-button" @click="scrollToTop">
        <div class="text-center w-full">
          <img
              :src="require('@/assets/img/goback.png')"
              class="Top-img"
              alt=""
          />
        </div>
        <div>回顶部</div>
      </div>
		</div>
    <el-dialog
        title="扫一扫立享免押租赁"
        :visible.sync="showRent"
        width="50%"
        :show-close="false"
        center
    >
      <div class="flex justify-center">
        <div style="margin-right: 30px;">
          <img :src="require('@/assets/img/app.png')" alt="二维码"  class="icon-img" />
          <div style="text-align: center">扫一扫，下载迪瓜APP</div>
        </div>
        <div>
          <img src="https://diguazu.oss-cn-shenzhen.aliyuncs.com/applet/2021003131606511_circle_blue_slogan_8cm.jpg" alt="二维码" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button @click="showRent = false">关闭</el-button>
			</span>
    </el-dialog>
	</div>
</template>

<script>
import FooterBar from './components/footerbar.vue';
export default {
	components: {
		FooterBar,
	},
	data() {
		return {
			showScrollToTop: false, // 控制按钮显示
      showRent:false,
		};
	},
	mounted() {
		// 监听滚动事件
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		// 移除滚动事件监听
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		// 处理滚动事件
		handleScroll() {
			this.showScrollToTop = window.scrollY > 200; // 滚动超过 200px 时显示按钮
		},
		// 返回顶部
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth', // 平滑滚动
			});
		},
    goH5(){
      window.open('https://api.diguazu.com/zhaoshang/index.html')
    }
	},
};
</script>
<style lang="scss">

#app {
	color: #1d2130;
	min-width: 1400px;
	.main {
		// max-width: 1920px;
		margin: 0 auto;
	}
}
a {
	&:hover {
		color: #00733d !important;
	}
	&:active {
		color: #00733d !important;
	}
}
.line-clamp-2 {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.max-width {
	max-width: 1400px;
}
.googBox_red {
	position: relative; // 确保伪元素定位正确
	&:hover {
		outline: 1px solid #00733d; // 最外层边框
		&::before {
			content: '';
			position: absolute;
			top: 0px; // 内层边框与外层边框的距离
			left: 0px;
			right: 0px;
			bottom: 0px;
			border: 2px solid white; // 内层白色边框
			pointer-events: none; // 确保伪元素不影响交互
			z-index: 999;
			border-radius: 8px;
		}
	}
}
.text-color-cb {
	color: #cbcbcb;
}
.scroll-to-top-btn {
	position: fixed;
	bottom: 30%;
	right: 0px;
	width: 40px;
	height: 40px;
	background-color: #fff;
	color: #000;
	border: none;
	border-radius: 50%;
	cursor: pointer;
	font-size: 15px;
	display: flex;
  flex-direction: column;
	align-items: center;
	justify-content: center;
	transition:
		opacity 0.3s ease,
		transform 0.3s ease;
}
.rounded-button {
	width: 91px;
	height: 300px;
	background: #ffffff;
	border-radius: 15px 0px 0px 15px;
	border: 1px solid #ebebeb;
  .top-button:not(:last-child)::after {
      content: '';
      position: absolute;
      bottom: -10px; /* 放在 border 的下方或覆盖下边框 */
      left: 10px;
      width:40px;
      right: 0; /* 横轴铺满 */
      height: 0.5px; /* 分隔线的高度 */
      background-color: #e3e4e4; /* 分隔线的颜色 */
      z-index: 1; /* 确保分隔线在需要时能覆盖其他内容 */
   }
  .top-button{
    width: 60px;
    text-align: center;
    position: relative;
    &:not(:last-child){
      margin-bottom: 10px;
    }
  }
}
.icon-img{
  width: 100%;
  height: 100%;
}
.Top-img {
	width: 45px;
	margin: 5px auto;
}
.font-c6{
	color: #666;
}
.font-c3{
	color: #666;
}
.font-c9{
	color: #666;
}
</style>
